import { render, staticRenderFns } from "./PROVREFUND.vue?vue&type=template&id=d6a2d1c2&scoped=true&"
import script from "./PROVREFUND.vue?vue&type=script&lang=js&"
export * from "./PROVREFUND.vue?vue&type=script&lang=js&"
import style0 from "./PROVREFUND.vue?vue&type=style&index=0&id=d6a2d1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a2d1c2",
  null
  
)

export default component.exports